export default function(){
    $(window).on('load', function () {
        // If link in embedded (iframe) email is clicked, redirect main window to link
        $('iframe').contents().find('a').on('click', function (e) {
            e.preventDefault();
            window.top.location.href = (<HTMLAnchorElement>e.target).href;
        });
    });
}